import { ConcreteEncodable } from "./ConcreteEncodable";

import { TrailingStopEventImplEncoder } from "../../encoder/TrailingStopEventImplEncoder";

import * as CubiqTS from "../../index";
import { TrailingStopEvent } from "../TrailingStopEvent";

export class TrailingStopEventImpl extends ConcreteEncodable implements TrailingStopEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.TrailingStopEventImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public trackingRate: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public rateId: string;
  /*FID=4*/
  public timeStamp: CubiqTS.Long | null = null;
  /*FID=5*/
  public isTrailActive: boolean;
  /*FID=6*/
  public productCode: string;
  /*FID=7*/
  public requestRate: CubiqTS.BigNumber | null = null;
  /*FID=8*/
  public trailingRate: CubiqTS.BigNumber | null = null;
  /*FID=9*/
  public hitRate: CubiqTS.MarketDataEvent | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TrailingStopEventImplEncoder.Instance;
    this.setEncodableType(TrailingStopEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TrailingStopEventImpl[" +
      "orderId=" +
      this.orderId +
      "trackingRate=" +
      this.trackingRate +
      "rateId=" +
      this.rateId +
      "timeStamp=" +
      this.timeStamp +
      "isTrailActive=" +
      this.isTrailActive +
      "productCode=" +
      this.productCode +
      "requestRate=" +
      this.requestRate +
      "trailingRate=" +
      this.trailingRate +
      "hitRate=" +
      this.hitRate +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
